export const BUSINESS = {
  name: "JMG Landscape",
  phone: "678-826-6954",
  phoneRaw: "6788266954",
  website: "www.JMGlandscape07.com",
  websiteUrl: "https://jmglandscape07.com",
  address: "330 Tuscany Trce, Dallas, Georgia",
  mapsUrl: "https://www.google.com/maps/search/?api=1&query=330+Tuscany+Trce+Dallas+Georgia",
  region: "Dallas, Georgia",
};

export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1780466744205-d8b21d3216e1?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000",
  design: "https://images.unsplash.com/photo-1779565145494-bab59ef83256?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  maintenance: "https://images.pexels.com/photos/6728925/pexels-photo-6728925.jpeg?auto=compress&cs=tinysrgb&w=1200",
  hardscape: "https://images.unsplash.com/photo-1698239343452-7f40e4b7849d?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  cleanup: "https://images.unsplash.com/photo-1605117882932-f9e32b03fea9?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  whyUs: "https://images.unsplash.com/photo-1757439402214-2311405d70bd?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  gallery: [
    { url: "https://images.unsplash.com/photo-1757264119016-7e6b568b810d?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200", title: "Modern Estate Pool & Lawn" },
    { url: "https://images.unsplash.com/photo-1749803915455-a7642520d0d3?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200", title: "Blooming Garden Beds" },
    { url: "https://images.unsplash.com/photo-1722768828489-43ef6eea82b8?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200", title: "Natural Stone Walkway" },
    { url: "https://images.pexels.com/photos/8143668/pexels-photo-8143668.jpeg?auto=compress&cs=tinysrgb&w=1200", title: "Manicured Estate Grounds" },
    { url: "https://images.unsplash.com/photo-1779565145494-bab59ef83256?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200", title: "Lush Garden Pathway" },
    { url: "https://images.unsplash.com/photo-1757439402277-1a88c7abc89d?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200", title: "Resort-Style Backyard" },
  ],
};
